import React from 'react';
import { TypedMemo } from '../../../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the lyric panel; each part uses its own slice of it */
import styles from './LyricLinePanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface LyricPanelEmptyProps {
  title: string;
  text: string;
  /** The button; absent: no button. */
  action?: { label: string; onClick: () => void };
}

/** An empty state of the panel (design b5): no lyrics, or no search result. */
const LyricPanelEmptyComponent: React.FC<LyricPanelEmptyProps> = ({ title, text, action }) => (
  <div className={styles.empty}>
    <b className={styles.emptyTitle}>{title}</b>
    <span>{text}</span>
    {action !== undefined && (
      <button type="button" className="btn btn-sm btn-primary" onClick={action.onClick}>
        {action.label}
      </button>
    )}
  </div>
);

export const LyricPanelEmpty = TypedMemo(LyricPanelEmptyComponent);
